import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { getWindowHeight } from "./get-window-height";

export const windowHeightUntilChanged = () => {
    return (source: Observable<any>) =>
        source.pipe(
            map(getWindowHeight),
            distinctUntilChanged()
        );
};
